import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents }: ComposedTheme) => {
  const { input, select } = formComponents;
  return {
    caret: {
      ...select.caret,
      '&$dark': {
        color: select.darkIconFill,
      },
    },
    dark: {},
    darkRoot: {},
    error: {},
    root: {
      '& svg': {
        display: select.caretIcon,
        fill: select.iconFill,
        pointerEvents: 'none',
        position: 'absolute',
        right: select.caretRight,
        top: select.caretTop,
      },
      '&$darkRoot': {
        '& svg': {
          fill: select.darkIconFill,
        },
      },
      position: 'relative',
    },
    select: {
      '& option': {
        backgroundColor: select.optionBackground,
        color: select.optionColor,
      },
      '&$dark': {
        '& option': {
          backgroundColor: select.darkOptionBackground,
          color: select.darkOptionColor,
        },
        '&:focus': {
          outlineColor: select.darkFocusColor,
        },
        backgroundColor: input.dark.backgroundColor,
        color: input.darkColor,
      },
      '&$error': {
        '&$dark': {
          borderColor: formComponents.dark.error.borderColor,
        },
        borderColor: formComponents.error.borderColor,
      },
      '&$warning$error': {
        '&$dark': {
          borderColor: formComponents.dark.warning.borderColor,
        },
        borderColor: formComponents.warning.borderColor,
      },
      '&::-ms-expand': {
        // necessary evil for IE 11, appearance should work in edge
        display: 'none',
      },
      '&:disabled': {
        backgroundColor: '#EDEDED',
        cursor: 'not-allowed',
        opacity: 1,
      },
      '&:focus': {
        outlineColor: select.focusColor,
      },
      appearance: 'none',
      background: input.backgroundColor,
      border: input.border,
      borderRadius: input.borderRadius,
      color: input.color,
      fontFamily: input.fontFamily,
      fontSize: input.fontSize,
      fontWeight: input.fontWeight,

      lineHeight: 1,

      padding: select.padding,

      width: '100%',
    },
    warning: {},
  };
};

export default createUseStyles(styles);
